import React from 'react'
import Image from 'next/image'
import StarIcon from '../../public/static/star-white.svg'
import { AnimatePresence } from 'framer-motion'
import { UserResponse } from '../../types/users/user-response'
import TransparentIcon from '../../public/static/transparent_1x1.png'
import { CategoryResponse } from '../../types/categories/responses/category-response'
import { isNil } from '../../common/utils/common.utils'

type Props = {
  teammate: UserResponse | undefined
  game: CategoryResponse | undefined
}

export function GlobeTeammateCard({ teammate, game }: Props) {
  const rank = teammate?.categoryProfiles
    ?.find((item) => {
      return item.isTeammate && item.categoryKey === game?.key
    })
    ?.categorySpecializedTags?.find((item) => item.parent.name === 'Rank')?.name

  function defaultRank(gameKey?: string) {
    switch (gameKey) {
      case 'league-of-legends':
        return 'Grandmaster'
      case 'valorant':
        return 'Radiant'
      case 'fortnite':
        return 'Unreal'
      case 'csgo':
        return 'Yellow: 30,000+'
      default:
        return ''
    }
  }

  return (
    <AnimatePresence>
      <div
        className={
          'flex h-32 flex-row gap-4 overflow-hidden bg-[#0F0F0F] opacity-100'
        }
      >
        <div className={'relative h-32 w-32'}>
          <Image
            src={teammate?.avatar?.imageUrl ?? TransparentIcon}
            fill={true}
            className={'object-cover'}
            alt={'Teammate avatar'}
          />
        </div>

        <div className={'flex w-fit flex-col justify-between gap-5 py-5'}>
          <div>
            <div
              className={
                'text-color-gray5 text-secondary-bold flex flex-row justify-between'
              }
            >
              <p className={'text-body-bold w-28 truncate'}>
                {teammate?.username ?? teammate?.fullName ?? ''}
              </p>

              <div
                className={
                  'ml-6 mr-4 flex flex-row items-center justify-between gap-1'
                }
              >
                <Image
                  src={StarIcon}
                  width={16}
                  height={16}
                  alt={'Star icon'}
                />

                <p>{teammate?.averageRating ?? '0'}</p>
              </div>
            </div>

            <div className={'flex flex-row items-center gap-1.5'}>
              <p className={'text-secondary-normal text-darul-100'}>
                {!isNil(rank) && rank !== '' ? rank : defaultRank(game?.key)}
              </p>
            </div>
          </div>

          {teammate?.country &&
            teammate.country.countryName &&
            teammate.country.iso31661Code && (
              <div
                className={
                  'text-secondary-normal flex w-48 flex-row items-center gap-1.5 truncate text-darul-100'
                }
              >
                <div className={'relative h-4 w-4 shrink-0 rounded-full'}>
                  <Image
                    src={
                      teammate.country.imageUrl ??
                      process.env.NEXT_PUBLIC_DEFAULT_IMAGE_URL!
                    }
                    fill={true}
                    className={'rounded-full object-cover'}
                    alt={teammate.country.countryName}
                  />
                </div>
                {teammate.country.countryName}
              </div>
            )}
        </div>
      </div>
    </AnimatePresence>
  )
}
